import { render } from "./tooltip.vue?vue&type=template&id=b21b7992&scoped=true"
import script from "./tooltip.vue?vue&type=script&lang=js"
export * from "./tooltip.vue?vue&type=script&lang=js"

import "./tooltip.vue?vue&type=style&index=0&id=b21b7992&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b21b7992"]])

export default __exports__